import { NgModule } from '@angular/core';
import { Routes, RouterModule, Router } from '@angular/router';
import { MainComponent } from './main/main.component';
import {AuthComponent} from '../app/auth/auth.component'
import { ComingSoonComponent } from './session/coming-soon/coming-soon.component';
import { LockScreenComponent } from './session/lockscreen/lockscreen.component';
import { PrepaidServicesComponent } from './modals/prepaid-services/prepaid-services.component';
export const AppRoutes: Routes = [
  // we can use route guards to protect the routes if user can activate returns true
  // we can use a service which has functions in them to check if user has login details

  // {
  //   path: 'register',
  //   component: RegisterComponent
  // },
  
  {
    path: '',
    component: AuthComponent,
    children: [
      {
        path: 'session',
        loadChildren: 'app/session/session.module#SessionDemoModule'
      }
    ]
  },
  {
    path: 'privacy-policy',
    component: ComingSoonComponent
  },
  {
    path: 'checkout-card-payment',
    component: LockScreenComponent
  },
 
  {
    path: '',
    component: MainComponent,
    children: [
      {
        path: 'report-calculation',
        loadChildren: './pages/report/report-calculation/report-calculation.module#ReportCalculationModule'
      },
      {
        path: 'non-academic-management',
        loadChildren: './modules-for-lazyloading/non-academic/non-academic.module#NonAcademicModule'
      },
      {
        path: 'my-subscriptions',
        loadChildren: './modals/prepaid-services/prepaid-services.module#PrepaidServicesModule'
      },
      {
        path: 'school-subscriptions',
        loadChildren: './modals/prepaid-services/prepaid-services.module#PrepaidServicesModule'
      },
      {
        path: 'child-assessment-report',
        loadChildren: './modules-for-lazyloading/non-academic/child-assessment-report.module#ChildAssessmentReportModule'
      },
      {
        path: 'assessment-category-comments',
        loadChildren: './modules-for-lazyloading/non-academic/assessment-category-comments.module#AssessmentCategoryCommentsModule'
      },
      {
        path: 'development-category',
        loadChildren: './modules-for-lazyloading/non-academic/development-category.module#DevelopmentCategoryModule'
      },
      {
        path: 'development-assessment-rating',
        loadChildren: './modules-for-lazyloading/non-academic/development-assessment-rating.module#DevelopmentAssessmentRatingsModule'
      },
      {
        path: 'setup-and-configuration',
        loadChildren: './modules-for-lazyloading/settings/settings.module#SettingsModule'
      },
      {
        path: 'bulk-data-upload-report',
        loadChildren: './modules-for-lazyloading/settings/bulk-data-upload-report.module#BulkDataUploadReportModule'
      },
      {
        path: 'user-roles',
        loadChildren: './modules-for-lazyloading/settings/user-roles.module#UserRolesModule'
      },
      {
        path: 'setup-employee-evaluation',
        loadChildren: './modules-for-lazyloading/settings/employee-evaluation-setup.module#EmployeeEvaluationSetupModule'
      },
      {
        path: 'academic-report-setup',
        loadChildren: './modules-for-lazyloading/settings/academic-report-setup.module#AcademicReportSetupModule'
      },
      {
        path: 'administration',
        loadChildren: './modules-for-lazyloading/administration/administration.module#AdministrationModule'
      },
      {
        path: 'school-management-forms',
        loadChildren: './modules-for-lazyloading/administration/incident-management.module#IncidentManagementModule'
      },
      {
        path: 'ids-school-form',
        loadChildren: './modules-for-lazyloading/administration/incident-management.module#IncidentManagementModule'
      },
      {
        path: 'school-term-review',
        loadChildren: './modules-for-lazyloading/administration/school-term-review.module#SchoolTermReviewModule'
      },
      {
        path: 'school-duty-roster',
        loadChildren: './modules-for-lazyloading/administration/school-duty-rooster.module#EmployeeDutyRoosterModule'
      },
      {
        path: 'bulk-enrollment',
        loadChildren: './modules-for-lazyloading/settings/bulk-enroll.module#BulkEnrollModule'
      },
      // {students
      //   path: 'bulk-enroll-staff',
      //   loadChildren: './modules-for-lazyloading/settings/bulk-enroll.module#BulkEnrollModule'
      // },
      // {
      //   path: 'bulk-enroll-teachers',
      //   loadChildren: './modules-for-lazyloading/settings/bulk-enroll.module#BulkEnrollModule'
      // },
      {
        path: 'final-report-template-setup',
        loadChildren: './modules-for-lazyloading/settings/final-report-template-setup.module#FinalAcademicReportTemplateSetupModule'
      },
      {
        path: 'school-departments',
        loadChildren: './modules-for-lazyloading/settings/ui-setup.module#UiSetupModule'
      },
      {
        path: 'detail-progress-report',
        loadChildren: './modules-for-lazyloading/report/detail-progress-report.module#DetailProgressReportModule'
      },
      {
        path: 'lesson-planner-setup',
        loadChildren: './modules-for-lazyloading/settings/ui-setup.module#UiSetupModule'
      },
      {
        path: 'medical-condition-setup',
        loadChildren: './modules-for-lazyloading/settings/ui-setup.module#UiSetupModule'
      },
      {
        path: 'medical-treatment-setup',
        loadChildren: './modules-for-lazyloading/settings/ui-setup.module#UiSetupModule'
      },
      {
        path: 'school-pdf-templates',
        loadChildren: './modules-for-lazyloading/settings/ui-setup.module#UiSetupModule'
      },
      {
        path: 'behavior-setup',
        loadChildren: './modules-for-lazyloading/settings/ui-setup.module#UiSetupModule'
      },
      {
        path: 'school-awards-setup',
        loadChildren: './modules-for-lazyloading/settings/ui-setup.module#UiSetupModule'
      },
      {
        path: 'setup-assessment-type',
        loadChildren: './modules-for-lazyloading/settings/ui-setup.module#UiSetupModule'
      },
      // {
      //   path: 'school-behavior-list',
      //   loadChildren: './modules-for-lazyloading/settings/ui-setup.module#UiSetupModule'
      // },
      {
        path: 'request-support',
        loadChildren: './modules-for-lazyloading/administration/request-support.module#RequestSupportModule'
      },
      {
        path: 'create-organization',
        loadChildren: './modules-for-lazyloading/administration/create-organization.module#CreateOrganizationModule'
      },
      {
        path: 'review-organization',
        loadChildren: './modules-for-lazyloading/administration/review-organization.module#ReviewOrganizationModule'
      },
      {
        path: 'update-organization',
        loadChildren: './modules-for-lazyloading/administration/review-organization.module#ReviewOrganizationModule'
      },
      {
        path: 'add-update-school-term',
        loadChildren: './modules-for-lazyloading/administration/add-new-school-term.module#AddNewSchoolTermModule'
      },
      {
        path: 'review-approver-signature',
        loadChildren: './modules-for-lazyloading/administration/review-approver-signature.module#ReviewApproverSignatureModule'
      },
      {
        path: 'buy-sms',
        loadChildren: './modules-for-lazyloading/administration/buy-sms.module#BuySmsModule'
      },
      {
        path: 'review-school-groups',
        loadChildren: './modules-for-lazyloading/administration/review-school-groups.module#ReviewSchoolGroupsModule'
      },
      {
        path: 'approver-signature',
        loadChildren: './modules-for-lazyloading/administration/approver-signature.module#ApproverSignatureModule'
      },
      {
        path: 'switch-accounts',
        loadChildren: './modules-for-lazyloading/administration/switch-accounts.module#SwitchAccountsModule'
      },     
      {
        path: 'review-school-groups/add',
        loadChildren: './modules-for-lazyloading/administration/review-school-groups.module#ReviewSchoolGroupsModule'
      },
      {
        path: 'external-examination-results',
        loadChildren: './modules-for-lazyloading/report/external-examination-results.module#ExternalExaminationResultModule'
      },
      {
        path: 'notification',
        loadChildren: './modules-for-lazyloading/notifications/notifications.module#NotificationsModule'
      },
      {
        path: 'upload',
        loadChildren: './modules-for-lazyloading/upload/upload.module#UploadModule'
      },
      {
        path: 'image-migration',
        loadChildren: './modules-for-lazyloading/upload/whats-new.module#WhatsNewModule'
      },
      {
        path: 'fileList',
        loadChildren: './modules-for-lazyloading/fileList/fileList.module#FileListModule'
      },
      {
        path: 'home',
        loadChildren: './modules-for-lazyloading/home/home.module#HomeModule'
      },
      {
        path: 'bulk-export',
        loadChildren: './modules-for-lazyloading/bulk-export/bulk-export.module#BulkExportModule'
      },
      {
        path: 'student-management',
        loadChildren: './modules-for-lazyloading/student/student.module#StudentModule'
      },
      {
        path: 'staff-teacher-management',
        loadChildren: './modules-for-lazyloading/staff-teacher/staff-teacher.module#StaffTeacherModule'
      },
      {
        path: 'school-boarding-house',
        loadChildren: './modules-for-lazyloading/student/school-boarding-house.module#SchoolBoardingHouseModule'
      },
      {
        path: 'financial-management',
        loadChildren: './modules-for-lazyloading/financial/financialmanagement/financialmanagement.module#FinancialmanagementModule'
      },
      {
        path: 'report-management',
        loadChildren: './modules-for-lazyloading/report/report.module#ReportModule'
      },
      {
        path: 'payroll-management',
        loadChildren: './modules-for-lazyloading/payroll/payroll.module#PayrollModule'
      },
      {
        path: 'create-multiple-employee-payslip',
        loadChildren: './modules-for-lazyloading/payroll/create-multiple-employee-payslip.module#CreateMultipleEmployeePayslipModule'
      },
      {
        path: 'create-employee-payslip',
        loadChildren: './modules-for-lazyloading/payroll/create-employee-payslip.module#CreateEmployeePayslipModule'
      },
      {
        path: 'payroll-deduction-addition',
        loadChildren: './modules-for-lazyloading/payroll/payroll-deduction-addition.module#PayrollDeductionAdditionModule'
      },
      {
        path: 'payroll-report-export',
        loadChildren: './modules-for-lazyloading/payroll/payroll-report-export.module#ReviewPayrollDedAddModule'
      },
      {
        path: 'payroll-payment',
        loadChildren: './modules-for-lazyloading/payroll/payroll-payment.module#PayrollPaymentModule'
      },
      {
        path: 'setup-employee-loan-terms',
        loadChildren: './modules-for-lazyloading/payroll/setup-employee-loan-terms.module#SetupEmployeeLoanTermsModule'
      },
      {
        path: 'record-employee-loan',
        loadChildren: './modules-for-lazyloading/payroll/record-employee-loan.module#RecordEmployeeLoanModule'
      },
      {
        path: 'review-employee-loan-terms',
        loadChildren: './modules-for-lazyloading/payroll/record-employee-loan.module#RecordEmployeeLoanModule'
      },
      {
        path: 'review-employee-payroll',
        loadChildren: './modules-for-lazyloading/payroll/review-employee-payroll.module#ReviewEmployeePayrollModule'
      },
      {
        path: 'employee-payroll-details',
        loadChildren: './modules-for-lazyloading/payroll/setup-employees-deduction-addition.module#SetupEmployeesDeductionAdditionModule'
      },
      {
        path: 'generate-payslip-pdf',
        loadChildren: './modules-for-lazyloading/payroll/generate-payslip-pdf.module#GeneratePayslipPdfModule'
      },
      {
        path: 'payroll-summary-report',
        loadChildren: './modules-for-lazyloading/payroll/payroll-summary-report.module#PayrollSummaryReportModule'
      },
      {
        path: 'extended-payroll-summary-report',
        loadChildren: './modules-for-lazyloading/payroll/payroll-summary-report.module#PayrollSummaryReportModule'
      },
      {
        path: 'my-payslips',
        loadChildren: './modules-for-lazyloading/payroll/my-payslips.module#MyPayslipsModule'
      },
      {
        path: 'classroom-management',
        loadChildren: './modules-for-lazyloading/classroom/classroom.module#ClassroomModule'
      },
      {
        path: 'inventory-management',
        loadChildren: './modules-for-lazyloading/inventory/inventory.module#InventoryModule'
      },
      {
        path: 'inventory-items',
        loadChildren: './modules-for-lazyloading/inventory/inventory-items/inventory-items.module#InventoryItemsModule'
      },
      {
        path: 'inventory-report',
        loadChildren: './modules-for-lazyloading/inventory/inventory-report/inventory-report.module#InventoryReportModule'
      },
      {
        path: 'inventory-items-by-vendor',
        loadChildren: './modules-for-lazyloading/inventory/inventory-items-by-vendor/inventory-items-by-vendor.module#InventoryItemsByVendorModule'
      },
      {
        path: 'inventory-categories',
        loadChildren: './modules-for-lazyloading/inventory/inventory-categories/inventory-categories.module#InventoryCategoriesModule'
      },
      {
        path: 'inventory-group',
        loadChildren: './modules-for-lazyloading/inventory/inventory-group/inventory-group.module#InventoryGroupModule'
      },
      {
        path: 'course-management',
        loadChildren: './modules-for-lazyloading/courses/courses.module#CoursesModule'
      },
      {
        path: 'message-inbox',
        loadChildren: './modules-for-lazyloading/administration/setup-gbook.module#SetupGbookModule'
      },
      {
        path: 'user-accounts',
        loadChildren: './modules-for-lazyloading/administration/employee-account-status.module#EmployeeAccountStatusModule'
      },
      {
        path: 'grading-scale',
        loadChildren: './modules-for-lazyloading/administration/grading-scale.module#GradingScaleModule'
      },
      {
        path: 'school-message-template',
        loadChildren: './modules-for-lazyloading/administration/school-message-template.module#SchoolMessageTemplateModule'
      },
      {
        path: 'school-vendors',
        loadChildren: './modules-for-lazyloading/administration/school-vendors.module#SchoolVendorsModule'
      },
      {
        path: 'bulk-pdf-status',
        loadChildren: './modules-for-lazyloading/administration/bulk-pdf-status.module#BulkPdfStatusModule'
      },
      {
        path: 'review-school-branch',
        loadChildren: './modules-for-lazyloading/administration/review-school-branch.module#ReviewSchoolBranchModule'
      },
      {
        path: 'add-update-branch',
        loadChildren: './modules-for-lazyloading/administration/add-update-branch.module#AddUpdateBranchModule'
      },
      {
        path: 'pickup-dropoff-person',
        loadChildren: './modules-for-lazyloading/administration/create-pickup-dropoff-person.module#CreatePickupDropoffPersonModule'
      },
      {
        path: 'school-notification-report',
        loadChildren: './modules-for-lazyloading/administration/school-notification-report.module#SchoolNotificationReportModule'
      },
      {
        path: 'notification-settings',
        loadChildren: './modules-for-lazyloading/administration/notification-settings.module#NotificationSettingsModule'
      },
      {
        path: 'school-daily-attendance-summary',
        loadChildren: './modules-for-lazyloading/administration/school-daily-attendance-summary.module#SchoolDailyAttendanceSummaryModule'
      },
      {
        path: 'create-school',
        loadChildren: './modules-for-lazyloading/administration/create-school.module#CreateSchoolModule'
      },
      {
        path: 'update-school-profile',
        loadChildren: './modules-for-lazyloading/administration/update-school-profile.module#UpdateSchoolProfileModule'
      },
      {
        path: 'school-financial-accounts',
        loadChildren: './modules-for-lazyloading/administration/summary-canteen-review.module#SummaryCanteenReviewModule'
      },
      {
        path: 'school-calendar',
        loadChildren: './modules-for-lazyloading/administration/school-calendar.module#SchoolCalendarModule'
      },
      {
        path: 'school-daily-activity',
        loadChildren: './modules-for-lazyloading/administration/school-daily-activity.module#SchoolDailyActivityModule'
      },
      {
        path: 'school-network-protection',
        loadChildren: './modules-for-lazyloading/administration/school-network-protection.module#SchoolNetworkProtectionModule'
      },
      {
        path: 'backend-service-settings',
        loadChildren: './modules-for-lazyloading/administration/backend-service-settings.module#BackendServiceSettingsModule'
      },
      {
        path: 'setup-school-currency',
        loadChildren: './modules-for-lazyloading/administration/canteen-menu.module#CanteenMenuModule'
      },
      {
        path: 'canteen',
        loadChildren: './modules-for-lazyloading/administration/canteen.module#CanteenModule'
      },
      {
        path: 'final-report',
        loadChildren: './modules-for-lazyloading/report/final-report.module#FinalReportModule'
      },
      {
        path: 'bece-forecaster',
        loadChildren: './modules-for-lazyloading/report/bece-forecaster.module#BeceForecasterModule'
      },
      {
        path: 'progress-report-tracker',
        loadChildren: './modules-for-lazyloading/report/progress-report.module#ProgressReportModule'
      },
      {
        path: 'generate-progress-report',
        loadChildren: './modules-for-lazyloading/report/generate-report.module#GenerateReportModule'
      },
      {
        path: 'progress-report-gpa',
        loadChildren: './modules-for-lazyloading/report/review-report.module#ReviewReportModule'
      },
      {
        path: 'view-progress-report',
        loadChildren: './modules-for-lazyloading/report/view-report.module#ViewReportModule'
      },
      {
        path: 'review-class-progress-report',
        loadChildren: './modules-for-lazyloading/report/review-class-progress-report.module#ReviewClassProgressReportModule'
      },
      {
        path: 'send-progress-report',
        loadChildren: './modules-for-lazyloading/report/send-report.module#SendReportModule'
      },
      {
        path: 'progress-report-status',
        loadChildren: './modules-for-lazyloading/report/report-status.module#ReportStatusModule'
      },
      {
        path: 'progress-report-subject-position',
        loadChildren: './modules-for-lazyloading/report/progress-report-subject-position.module#ProgressReportSubjectPositionModule'
      },
      {
        path: 'household-billing',
        loadChildren: './modules-for-lazyloading/financial/create-new-invoice-bill.module#CreateNewInvoiceBillModule'
      },
      {
        path: 'selective-bill',
        loadChildren: './modules-for-lazyloading/financial/selective-bill/selective-bill.module#SelectiveBillModule'
      },
      {
        path: 'bulk-edit-bills',
        loadChildren: './modules-for-lazyloading/financial/bulk-edit-bills/bulk-edit-bill.module#BulkEditInvoiceBillModule'
      },
      {
        path: 'pay-bill',
        loadChildren: './modules-for-lazyloading/financial/pay-bill/pay-bill.module#PayBillModule'
      },
      {
        path: 'grades-review',
        loadChildren: './modules-for-lazyloading/classroom/grades-review/grades-review.module#GradesReviewModule'
      },
      {
        path: 'raw-grade-recording',
        loadChildren: './modules-for-lazyloading/classroom/raw-grade-recording/raw-grade-recording.module#RawGradeRecordingModule'
      },
      {
        path: 'student-attendance',
        loadChildren: './modules-for-lazyloading/classroom/student-attendance/student-attendance.module#StudentAttendanceModule'
      },
      {
        path: 'weekly-attendance',
        loadChildren: './modules-for-lazyloading/classroom/weekly-attendance/weekly-attendance.module#WeeklyAttendanceModule'
      },
      {
        path: 'attendance-summary',
        loadChildren: './modules-for-lazyloading/classroom/attendance-summary/attendance-summary.module#AttendanceSummaryModule'
      },
      {
        path: 'lesson-plan',
        loadChildren: './modules-for-lazyloading/classroom/lesson-plan/lesson-plan.module#LessonPlanModule'
      },
      {
        path: 'ib-lesson-plan',
        loadChildren: './modules-for-lazyloading/classroom/ib-lesson-plan/ib-lesson-plan.module#IbLessonPlanModule'
      },
      {
        path: 'weekly-work-plan',
        loadChildren: './modules-for-lazyloading/classroom/weekly-work-plan/weekly-work-plan.module#WeeklyWorkPlanModule'
      },
      {
        path: 'ges-scheme-of-learning',
        loadChildren: './modules-for-lazyloading/classroom/ges-scheme-of-learning/ges-scheme-of-learning.module#GesSchemeOfLearningModule'
      },
      {
        path: 'classroom-schedule',
        loadChildren: './modules-for-lazyloading/classroom/classroom-schedule/classroom-schedule.module#ClassroomScheduleModule'
      },
      {
        path: 'classroom-notification',
        loadChildren: './modules-for-lazyloading/classroom/classroom-notification/classroom-notification.module#ClassroomNotificationModule'
      },
      {
        path: 'classroom-notification-history',
        loadChildren: './modules-for-lazyloading/classroom/classroom-notification-history/classroom-notification-history.module#ClassroomNotificationHistoryModule'
      },
      {
        path: 'class-performance-report',
        loadChildren: './modules-for-lazyloading/classroom/class-performance-report/class-performance-report.module#ClassPerformanceReportModule'
      },
      {
        path: 'voucher-report',
        loadChildren: './modules-for-lazyloading/financial/voucher-report/voucher-report.module#VoucherReportModule'
      },
      {
        path: 'accounts-receivable-report',
        loadChildren: './modules-for-lazyloading/financial/accounts-receivable-report/accounts-receivable-report.module#AccountsReceivableReportModule'
      },
      {
        path: 'account-payable-report',
        loadChildren: './modules-for-lazyloading/financial/accounts-payable-report/accounts-payable-report.module#AccountPayableReportModule'
      },

      {
        path: 'invoice-bill-report',
        loadChildren: './modules-for-lazyloading/financial/invoice-bill-report/invoice-bill-report.module#InvBillReportModule'
      },
      {
        path: 'discount-report',
        loadChildren: './modules-for-lazyloading/financial/discount-report/discount-report.module#DiscountReportModule'
      },
      {
        path: 'new-course-setup',
        loadChildren: './modules-for-lazyloading/courses/new-course.module#NewCourseModule'
      },
      {
        path: 'show-available-courses/add',
        loadChildren: './modules-for-lazyloading/courses/show-available-courses.module#showAvailableCoursesModule'
      },
      {
        path: 'show-available-courses',
        loadChildren: './modules-for-lazyloading/courses/show-available-courses.module#showAvailableCoursesModule'
      },
      {
        path: 'move-students-from-course',
        loadChildren: './modules-for-lazyloading/courses/move-students-from-course.module#MoveStudentsFromCourseModule'
      },
      {
        path: 'students-by-course',
        loadChildren: './modules-for-lazyloading/courses/students-by-course.module#StudentsByCourseComponentModule'
      },
      {
        path: 'assign-student-course',
        loadChildren: './modules-for-lazyloading/courses/assign-student-course.module#AssignStudentCourseModule'
      },
      {
        path: 'course-teacher-link',
        loadChildren: './modules-for-lazyloading/courses/course-teacher-link.module#CourseTeacherLinkModule'
      },
      {
        path: 'assign-course-category',
        loadChildren: './modules-for-lazyloading/courses/assign-course-category.module#AssignCourseCategoryModule'
      },
      {
        path: 'payment-history',
        loadChildren: './modules-for-lazyloading/financial/payment-history/payment-history.module#PaymentHistoryModule'
      },
      {
        path: 'school-revenue-report',
        loadChildren: './modules-for-lazyloading/financial/school-revenue-report/school-revenue-report.module#SchoolRevenueReportModule'
      },
      {
        path: 'school-expense-report',
        loadChildren: './modules-for-lazyloading/financial/school-expense-report/school-expense-report.module#SchoolExpenseReportModule'
      },
      {
        path: 'financial-account-history',
        loadChildren: './modules-for-lazyloading/financial/financial-account-history/financial-account-history.module#FinancialAccountHistoryModule'
      },
      {
        path: 'financial-account-balance',
        loadChildren: './modules-for-lazyloading/financial/financial-account-balance/financial-account-balance.module#FinancialAccountBalanceModule'
      },
      {
        path: 'financial-report-exclusions',
        loadChildren: './modules-for-lazyloading/financial/financial-account-balance/financial-account-balance.module#FinancialAccountBalanceModule'
      },
      {
        path: 'daily-transactional-report',
        loadChildren: './modules-for-lazyloading/financial/daily-transactional-report/daily-transactional-report.module#DailyTransactionalReportModule'
      },
      {
        path: 'daily-financial-summary-report',
        loadChildren: './modules-for-lazyloading/financial/daily-financial-summary-report/daily-financial-summary-report.module#DailyFinancialSummaryReportModule'
      },
      {
        path: 'trial-balance',
        loadChildren: './modules-for-lazyloading/financial/sims-dash/sims-dash.module#SimsDashModule'
      },
      {
        path: 'student-account',
        loadChildren: './modules-for-lazyloading/financial/student-account/student-account.module#StudentAccountModule'
      },
      {
        path: 'funds-transfer',
        loadChildren: './modules-for-lazyloading/financial/funds-transfer/funds-transfer.module#FundsTransferModule'
      },
      {
        path: 'cash-flow-statement',
        loadChildren: './modules-for-lazyloading/financial/cash-flow-statement/cash-flow-statement.module#CashFlowStatementModule'
      },
      {
        path: 'external-payment-report',
        loadChildren: './modules-for-lazyloading/financial/externalpaymentreport/externalpaymentreport.module#ExternalpaymentreportModule'
      },
      {
        path: 'pay-expense-report',
        loadChildren: './modules-for-lazyloading/financial/pay-expense-report/pay-expense-report.module#PayExpenseReportModule'
      },
      {
        path: 'record-expense',
        loadChildren: './modules-for-lazyloading/financial/record-expense/record-expense.module#RecordExpenseModule'
      },
      {
        path: 'update-expense',
        loadChildren: './modules-for-lazyloading/financial/update-expense/update-expense.module#UpdateExpenseModule'
      },
      {
        path: 'profit-loss-statement',
        loadChildren: './modules-for-lazyloading/financial/profit-loss-statement/profit-loss-statement.module#ProfitLossStatementModule'
      },
      {
        path: 'on-demand-payment',
        loadChildren: './modules-for-lazyloading/financial/on-demand-payment/on-demand-payment.module#OnDemandPaymentModule'
      },
      {
        path: 'resend-payment-bill-payment',
        loadChildren: './modules-for-lazyloading/financial/resend-payment-notification/resend-payment-notification.module#ResendPaymentNotificationModule'
      },
      {
        path: 'selective-on-demand-payment',
        loadChildren: './modules-for-lazyloading/financial/selective-on-demand-payment/selective-on-demand-payment.module#SelectiveOnDemandPaymentModule'
      },
      {
        path: 'setup-student-invoice-items',
        loadChildren: './modules-for-lazyloading/financial/setup-student-invoice-items/setup-student-invoice-items.module#SetupStudentInvoiceItemsModule'
      },
      {
        path: 'chart-of-accounts',
        loadChildren: './modules-for-lazyloading/financial/chart-of-accounts/chart-of-accounts.module#ChartOfAccountsModule'
      },
      {
        path: 'chart-of-account-balance',
        loadChildren: './modules-for-lazyloading/financial/chart-of-accounts-balance/chart-of-accounts-balance.module#ChartOfAccountsBalanceModule'
      },
      {
        path: 'student-financial-statement',
        loadChildren: './modules-for-lazyloading/financial/student-financial-statement/student-financial-statement.module#StudentFinancialStatementModule'
      },
      {
        path: 'org-rev-report',
        loadChildren: './modules-for-lazyloading/financial/org-rev-report/org-rev-report.module#OrgRevReportModule'
      },
      {
        path: 'review-school-invoice-items',
        loadChildren: './modules-for-lazyloading/financial/review-school-invoice-items/review-school-invoice-items.module#ReviewSchoolInvoiceItemsModule'
      },
      {
        path: 'daily-fee-recon',
        loadChildren: './modules-for-lazyloading/financial/daily-fee-recon/daily-fee-recon.module#DailyFeeReconModule'
      },
      {
        path: 'line-item-on-demand-payment',
        loadChildren: './modules-for-lazyloading/financial/line-item-on-demand-payment/line-item-on-demand-payment.module#LineItemOnDemandPaymentModule'
      },
      {
        path: 'setup-class-invoice-items',
        loadChildren: './modules-for-lazyloading/financial/create-selective-bill-invoice.module#CreateSelectiveBillInvoiceModule'
      },
      {
        path: 'bulk-billing',
        loadChildren: './modules-for-lazyloading/financial/bulk-billing/bulk-billing.module#BulkBillingModule'
      },
      {
        path: 'bulk-pay-bill-item',
        loadChildren: './modules-for-lazyloading/financial/bulk-pay-bill-item/bulk-pay-bill-item.module#BulkPayBillItemModule'
      },
      {
        path: 'payment-history-line-item-report',
        loadChildren: './modules-for-lazyloading/financial/payment-history-line-item-report/payment-history-line-item-report.module#PaymentHistoryLineItemReportModule'
      },
      {
        path: 'invoice-bill-line-item-report',
        loadChildren: './modules-for-lazyloading/financial/invoice-bill-line-item-report/invoice-bill-line-item-report.module#InvoiceBillLineItemReportModule'
      },
      {
        path: 'invoice-bill-age-report',
        loadChildren: './modules-for-lazyloading/financial/invoice-bill-age-report/invoice-bill-age-report.module#InvoiceBillAgeReportModule'
      },
      {
        path: 'bad-debts-report',
        loadChildren : './modules-for-lazyloading/financial/baddebtreport/baddebtreport.module#BaddebtreportModule'
      },
      {
        path: 'bill-item',
        loadChildren : './modules-for-lazyloading/financial/bill-item/bill-item.module#BillItemModule'
      },
      {
        path: 'advance-payment-report',
        loadChildren : './modules-for-lazyloading/financial/advancepaymentreport/advancepaymentreport.module#AdvancepaymentreportModule'
      },
      {
        path: 'funds-transfer-report',
        loadChildren : './modules-for-lazyloading/financial/funds-transfer-report/funds-transfer-report.module#FundsTransferReportModule'
      },
      {
        path: 'employee-assessment',
        loadChildren : './modules-for-lazyloading/staff-teacher/employee-assessment/employee-assessment.module#EmployeeAssessmentModule'
      },
      {
        path: 'employee-time-off',
        loadChildren : './modules-for-lazyloading/staff-teacher/manage-timeoff/employee-timeoff.module#manageTimeOffModule'
      },
      {
        path: 'search-employee',
        loadChildren : './modules-for-lazyloading/staff-teacher/search-employee/search-employee.module#SearchEmployeeModule'
      },
      {
        path: 'bulk-employee-attendance',
        loadChildren: './modules-for-lazyloading/staff-teacher/bulk-employee-attendance/bulk-employee-attendance.module#BulkEmployeeAttendanceModule'
      },
      {
        path: 'employee-performance',
        loadChildren : './modules-for-lazyloading/staff-teacher/employee-performance/employee-performance.module#EmployeePerformanceModule'
      },
      {
        path: 'employee-attendance',
        loadChildren : './modules-for-lazyloading/staff-teacher/employee-attendance/employee-attendance.module#EmployeeAttendanceModule'
      },
      {
        path: 'employee-setup',
        loadChildren : './modules-for-lazyloading/staff-teacher/employee-setup/employee-setup.module#EmployeeSetupModule'
      },
      {
        path: 'my-profile',
        loadChildren : './modules-for-lazyloading/staff-teacher/update-employee-profile/update-employee-profile.module#UpdateEmployeeProfileModule'
      },
      {
        path: 'weekly-schedule',
        loadChildren : './modules-for-lazyloading/staff-teacher/update-employee-profile/update-employee-profile.module#UpdateEmployeeProfileModule'
      },
      {
        path: 'update-employee-profile',
        loadChildren : './modules-for-lazyloading/staff-teacher/update-employee-profile/update-employee-profile.module#UpdateEmployeeProfileModule'
      },
      {
        path: 'employee-dashboard',
        loadChildren : './modules-for-lazyloading/staff-teacher/employee-dashboard/employee-dashboard.module#EmployeeDashboardModule'
      },
      {
        path: 'review-employee-assessment',
        loadChildren : './modules-for-lazyloading/staff-teacher/review-employee-assessment/review-employee-assessment.module#ReviewEmployeeAssessmentModule'
      },
      {
        path: 'staff-teacher-by-group',
        loadChildren : './modules-for-lazyloading/staff-teacher/staff-teacher-by-group/staff-teacher-by-group.module#StaffTeacherByGroupModule'
      },
      {
        path: 'staff-teacher-by-group/add',
        loadChildren : './modules-for-lazyloading/staff-teacher/staff-teacher-by-group/staff-teacher-by-group.module#StaffTeacherByGroupModule'
      },
      {
        path: 'move-emp-in-group',
        loadChildren : './modules-for-lazyloading/staff-teacher/move-staff-teacher-in-group/move-staff-teacher-in-group.module#MoveStaffTeacherInGroupModule'
      },
      {
        path: 'staff-notice',
        loadChildren : './modules-for-lazyloading/staff-teacher/staff-notice/staff-notice.module#StaffNoticeModule'
      },
  
      {
        path: 'final-report-comment',
        loadChildren : './modules-for-lazyloading/report/final-report-comment.module#FinalReportCommentModule'
      },
      {
        path: 'final-report-comment/prog',
        loadChildren : './modules-for-lazyloading/report/final-report-comment.module#FinalReportCommentModule'
      },
      {
        path: 'assessment-report-comment',
        loadChildren : './modules-for-lazyloading/report/assessment-report-comment.module#AssessmentReportCommentModule'
      },
      {
        path: 'balance-sheet',
        loadChildren : './modules-for-lazyloading/financial/balance-sheet/balance-sheet.module#BalanceSheetModule'
      },
      {
        path: 'depreciation-schedule',
        loadChildren : './modules-for-lazyloading/financial/depreciation-schedule/depreciation-schedule.module#DepreciationScheduleModule'
      },
      {
        path: 'fixed-assets-report',
        loadChildren : './modules-for-lazyloading/financial/fixed-assets-report/fixed-assets-report.module#FixedAssetsReportModule'
      },
      {
        path: 'bank-activity-report',
        loadChildren : './modules-for-lazyloading/financial/bank-activity-report/bank-activity-report.module#BankActivityReportModule'
      },
      {
        path: 'record-revenue',
        loadChildren : './modules-for-lazyloading/financial/record-revenue/record-revenue.module#RecordRevenueModule'
      },
      {
        path: 'receive-revenue',
        loadChildren : './modules-for-lazyloading/financial/receive-revenue/receive-revenue.module#ReceiveRevenueModule'
      },
      {
        path: 'auto-generate-final-report',
        loadChildren: './modules-for-lazyloading/report/auto-generate-final-report.module#AutoGenerateFinalReportModule'
      },
      {
        path: 'manual-final-mark-entry-report',
        loadChildren: './modules-for-lazyloading/report/manual-final-mark-entry.module#ManualFinalMarkEntryModule'
      },
      {
        path: 'final-report-gpa',
        loadChildren: './modules-for-lazyloading/report/final-report-gpa.module#FinalReportGpaModule'
      },
      {
        path: 'final-report-analysis',
        loadChildren: './modules-for-lazyloading/report/final-report-analysis.module#FinalReportAnalysisModule'
      },
      {
        path: 'export-annual-final-report',
        loadChildren: './modules-for-lazyloading/report/export-annual-final-report.module#ExportAnnualFinalReportModule'
      },
      {
        path: 'export-progress-report-pdf',
        loadChildren: './modules-for-lazyloading/report/export-progress-report-pdf.module#ExportProgressReportPdfModule'
      },
      {
        path: 'final-report-quality-check',
        loadChildren: './modules-for-lazyloading/report/final-report-quality-check.module#FinalReportQualityCheckModule'
      },
      {
        path: 'final-report-subject-position',
        loadChildren: './modules-for-lazyloading/report/final-report-subject-position.module#FinalReportSubjectPositionModule'
      },
      {
        path: 'student-final-report-review',
        loadChildren: './modules-for-lazyloading/report/student-final-report-review.module#StudentFinalReportReviewModule'
      },
      {
        path: 'class-development-assessment',
        loadChildren: './modules-for-lazyloading/report/class-development-assessment.module#ClassDevelopmentAssessmentModule'
      },
      {
        path: 'child-development-assessment',
        loadChildren: './modules-for-lazyloading/report/child-development-assessment.module#ChildDevelopmentAssessmentModule'
      },
      {
        path: 'child-development-analysis',
        loadChildren: './modules-for-lazyloading/report/child-development-analysis.module#ChildDevelopmentAnalysisModule'
      },
      {
        path: 'student-award',
        loadChildren: './modules-for-lazyloading/report/student-award.module#StudentAwardModule'
      },
      {
        path: 'student-behavior',
        loadChildren: './modules-for-lazyloading/student/student-behavior.module#StudentBehaviorModule'
      },
      {
        path: 'student-behavior-review',
        loadChildren: './modules-for-lazyloading/student/student-behavior-review.module#StudentBehaviorReviewModule'
      },
      {
        path: 'view-final-report',
        loadChildren: './modules-for-lazyloading/report/view-final-report.module#ViewFinalReportModule'
      },
      {
        path: 'student-promotion',
        loadChildren: './modules-for-lazyloading/report/student-promotion.module#StudentPromotionModule'
      },
      {
        path: 'final-report-status',
        loadChildren: './modules-for-lazyloading/report/final-report-status.module#FinalReportStatusModule'
      },
      {
        path: 'send-final-report',
        loadChildren: './modules-for-lazyloading/report/send-final-report.module#SendFinalReportModule'
      },
      {
        path: 'final-report-broadsheet',
        loadChildren: './modules-for-lazyloading/report/final-marks-review.module#FinalMarksReviewModule'
      },
      {
        path: 'enroll-student',
        loadChildren: './modules-for-lazyloading/student/enroll-student.module#EnrollStudentModule'
      },
      {
        path: 'student-dashboard',
        loadChildren: './modules-for-lazyloading/student/search-student.module#SearchStudentModule'
      },
      {
        path: 'move-students',
        loadChildren: './modules-for-lazyloading/student/move-student.module#MoveStudentModule'
      },
      {
        path: 'review-student-daily-activity',
        loadChildren: './modules-for-lazyloading/student/review-student-daily-activity.module#ReviewStudentDailyActivityModule'
      },
      {
        path: 'student-admission-report',
        loadChildren: './modules-for-lazyloading/student/student-admission-report.module#StudentAdmissionReportModule'
      },
      {
        path: 'student-medical-history',
        loadChildren: './modules-for-lazyloading/student/student-medical-history.module#StudentMedicalHistoryModule'
      },
      {
        path: 'student-notification-history',
        loadChildren: './modules-for-lazyloading/student/student-notification-history.module#StudentNotificationHistoryModule'
      },
      {
        path: 'household-report',
        loadChildren: './modules-for-lazyloading/student/household-report.module#HouseholdReportModule'
      },
      {
        path: 'pickup-dropoff',
        loadChildren: './modules-for-lazyloading/student/pick-up-drop-off.module#PickUpDropOffModule'
      },
      {
        path: 'pickup-dropoff-log',
        loadChildren: './modules-for-lazyloading/student/pick-up-drop-off-log.module#PickUpDropOffLogModule'
      },
      {
        path: 'student-population',
        loadChildren: './modules-for-lazyloading/student/student-population.module#StudentPopulationModule'
      },
      {
        path: 'review-student-award',
        loadChildren: './modules-for-lazyloading/student/review-student-award.module#ReviewStudentAwardModule'
      },
      {
        path: 'student-transcript',
        loadChildren: './modules-for-lazyloading/student/ges-student-transcript.module#GesStudentTranscriptModule'
      },
      {
        path: 'permissions-mapping',
        loadChildren: './modules-for-lazyloading/student/igcse-student-transcript.module#IgcseStudentTranscriptModule'
      },
      {
        path: 'student-transcript-status',
        loadChildren: './modules-for-lazyloading/student/student-transcript-status.module#StudentTranscriptStatusModule'
      },
      // {
      //   path: 'assign-student-group',
      //   loadChildren: './modules-for-lazyloading/student/assign-student-group.module#AssignStudentGroupModule'
      // },
      {
        path: 'student-birthday-report',
        loadChildren: './modules-for-lazyloading/student/student-birthday-report.module#StudentBirthdayReportModule'
      },
      {
        path: 'search-inactive-student',
        loadChildren: './modules-for-lazyloading/student/search-inactive-students.module#SearchInactiveStudentsModule'
      },
      {
        path: 'student-mini-profile',
        loadChildren: './modules-for-lazyloading/student/student-mini-profile.module#StudentMiniProfileModule'
      },
      {
        path: 'update-student-profile',
        loadChildren: './modules-for-lazyloading/student/update-student-profile.module#UpdateStudentProfileModule'
      },
      {
        path: 'setup-dropoff-balance-check',
        loadChildren: './modules-for-lazyloading/student/setup-dropoff-balance-check.module#SetupDropOffBalanceCheckModule'
      },
      {
        path: 'unbilled-student-report',
        loadChildren: './modules-for-lazyloading/financial/unbilled-student-report/unbilled-student-report.module#UnbilledStudentReportModule'
      },
      {
        path: 'guided-mode',
        loadChildren : './modules-for-lazyloading/administration/guided-mode.module#GuidedModeModule'
      },
      {
        path: 'new-classroom-setup',
        loadChildren : './modules-for-lazyloading/classroom/new-classroom-setup/new-classroom-setup.module#NewClassroomSetupModule'
      },
      {
        path: 'move-students-in-group',
        loadChildren : './modules-for-lazyloading/classroom/move-students-in-group/move-students-in-group.module#MoveStudentsInGroupModule'
      },
      {
        path: 'students-by-group',
        loadChildren : './modules-for-lazyloading/classroom/students-by-group/students-by-group.module#StudentsByGroupModule'
      },
      {
        path: 'assign-student-group',
        loadChildren : './modules-for-lazyloading/classroom/assign-student-group/assign-student-group.module#AssignStudentGroupModule'
      },
      {
        path: 'student-active-inactive-reason',
        loadChildren : './modules-for-lazyloading/classroom/student-active-inactive-reason/student-active-inactive-reason.module#StudentActiveInactiveReasonModule'
      },
      {
        path: 'classroom-review',
        loadChildren : './modules-for-lazyloading/classroom/classroom-review/classroom-review.module#ClassroomReviewModule'
      },
      {
        path: 'update-classroom',
        loadChildren : './modules-for-lazyloading/classroom/update-classroom/update-classroom.module#UpdateClassroomModule'
      },
      {
        path: 'students-by-classroom',
        loadChildren : './modules-for-lazyloading/classroom/students-by-classroom/students-by-classroom.module#StudentsByClassroomModule'
      },
      //! all routes should be above the one below
      //this is to catch all routes that are not valid and prevent an error
      {
        path:'**', 
        redirectTo:'home'
      }
      
    ]
  }

];



// WEBPACK FOOTER //
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/src/app/app-routing.module.ts